export default __webpack_public_path__ + "static/media/workboard.dc5baf08.svg";